import { render, staticRenderFns } from "./ChangedHistory.vue?vue&type=template&id=129d14ff"
import script from "./ChangedHistory.vue?vue&type=script&lang=ts"
export * from "./ChangedHistory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports